module.exports = __webpack_public_path__ + "img/simple_automation_icon.d03dbc33.svg";